import { useQuery } from "@tanstack/react-query";
import { get } from "api/api-methods";
import { BookingMenu } from "types/menu";

export const useBookingMenu = (menuGuid: string) => {
    const getBookingMenu = async () => {
        try {
            return await get<BookingMenu>(`BookingMenu/BookingMenusExternal/${menuGuid}`);
        } catch (error) {
            console.error(error);
        }
    };

    return useQuery({
        queryFn: getBookingMenu,
        queryKey: ["booking-menu", menuGuid],
        refetchOnMount: false,
        enabled: !!menuGuid,
    });
};
